/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable react/self-closing-comp */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  Button,
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  Textarea,
  Input,
} from "@repo/ui";
import { useForm } from "react-hook-form";
import FormSelect from "ui/select";
import { useUpdateTicketStatus } from "services/tickets";
import sweetAlert from "components/sweet-alert";
import { Label } from "ui/label";
import { useUser } from "hooks/use-user";

const StatusLists = {
  Draft: [{ id: "Cancelled", text: "Cancel" }],
  Open: [{ id: "Cancelled", text: "Cancel" }],
  Assigned: [{ id: "Cancelled", text: "Cancel" }],
  Resolved: [{ id: "Closed", text: "Close" }],
  "Awaiting Customer Approval": [
    { id: "Rejected", text: "Reject" },
    { id: "Closed", text: "Close" },
  ],
  Closed: [{ id: "Re-Opening Requested", text: "Request Re-Opening" }],
  "Awaiting Re-Opening": [{ id: "Re-Opened", text: "Re-Open" }],
  "On Hold": [{ id: "Re-Assigned", text: "Re-Assigned" }],
};

export default function UpdateStatus({
  triggerButton,
  requestDetails,
  onReload,
}) {
  const user = useUser();
  const isCCACalls = user.Roles.includes("CC Calls");
  const {
    mutate: updateStatus,
    data: updateStatusResponse,
    isPending: updatingStatus,
    error: updateStatusError,
    reset: resetRequest,
  } = useUpdateTicketStatus();
  const form = useForm({
    defaultValues: { status: "", remarks: "", additionalRemarks: "" },
  });
  const generalProps = { errors: form.formState.errors, control: form.control };
  const verificationRules = {
    status: { required: "Please Select Status" },
    remarks: { required: "Please Enter Remarks" },
    additionalRemarks: { required: "Please Enter Additional Remarks" },
  };
  useEffect(() => {
    if (updateStatusResponse) {
      if (updateStatusResponse.status === 200) {
        sweetAlert({
          title: "Updated!!",
          text: `Status Updated`,
          icon: "success",
        });
        form.reset();
        resetRequest();
        if (onReload) {
          onReload();
        }
      }
    }
    if (updateStatusError) {
      form.setError("failure", {
        message:
          updateStatusError.status === 400
            ? updateStatusError.message
            : "Unable To update status",
      });
      // sweetAlert({
      //   title: "Failure!!",
      //   text: updateStatusError.message,
      //   icon: "error",
      // });
      //   form.reset();
      resetRequest();
      //   if (updateStatusResponse.status === 500) {
      //     sweetAlert({
      //       title: "Failure!!",
      //       text: updateStatusResponse.message,
      //       icon: "error",
      //     });
      //     form.reset();
      //     resetRequest();
      //   }
    }
  }, [updateStatusResponse, updateStatusError]);
  const submitInfo = (data) => {
    const payload = {
      status: data.status,
      // pendingReason: data.pendingReason,
      remarks: data.remarks,
      additionalRemarks: data.additionalRemarks,
      ticketId: requestDetails.ticketId,
      resolutionCode: "",
      resolutionNotes: "",
    };
    updateStatus(payload);
  };
  const canCancel = useMemo(() => {
    return StatusLists[requestDetails.status]?.find(
      (elm) => elm.id === "Cancelled"
    );
  }, []);
  return (
    <Dialog
      onOpenChange={() => {
        form.reset();
      }}
    >
      <DialogTrigger asChild>{triggerButton}</DialogTrigger>
      <DialogContent
        onOpenAutoFocus={(e) => {
          e.preventDefault();
        }}
      >
        <DialogHeader>
          <DialogTitle className="mb-8">Update Status</DialogTitle>

          <Form {...form}>
            <form
              onSubmit={form.handleSubmit(submitInfo)}
              className="form-container-2"
              style={{ margin: 0, padding: 0 }}
            >
              <div className="profile-form flex flex-row flex-wrap gap-[4%]">
                <FormField
                  control={form.control}
                  name="customer"
                  render={() => (
                    <FormItem>
                      <Label label="Account" />
                      <FormControl>
                        <Input
                          disabled={updatingStatus}
                          value={requestDetails.customer}
                          className=" border-secondary"
                          readOnly
                        />
                      </FormControl>
                    </FormItem>
                  )}
                />
                <FormField
                  control={form.control}
                  name="assetId"
                  render={() => (
                    <FormItem>
                      <Label label="Asset ID" />
                      <FormControl>
                        <Input
                          disabled={updatingStatus}
                          value={requestDetails.locationId}
                          className="border-secondary"
                          readOnly
                        />
                      </FormControl>
                    </FormItem>
                  )}
                />
                <div className="w-full mb-4"></div>
                <FormField
                  control={form.control}
                  name="casNo"
                  render={() => (
                    <FormItem>
                      <Label label="Case No" />
                      <FormControl>
                        <Input
                          disabled={updatingStatus}
                          value={requestDetails.caseNo}
                          className="border-secondary"
                          readOnly
                        />
                      </FormControl>
                    </FormItem>
                  )}
                />
                <FormSelect
                  {...generalProps}
                  isRequired
                  name="status"
                  label="Status"
                  text="text"
                  hideIcons
                  labelStyle={{
                    justifyContent: "flex-start",
                    textAlign: "start",
                  }}
                  id="id"
                  data={
                    requestDetails.status && StatusLists[requestDetails.status]
                      ? StatusLists[requestDetails.status]
                      : []
                  }
                  disabled={updatingStatus || (isCCACalls && canCancel)}
                  rules={verificationRules.status}
                  dropdownProps={{ className: "border-secondary " }}
                />
              </div>
              <div className="w-full mb-4"></div>
              <FormField
                control={form.control}
                name="remarks"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Remarks</FormLabel>
                    <FormControl>
                      <Textarea
                        disabled={updatingStatus || (isCCACalls && canCancel)}
                        {...field}
                        className="min-w-full border-secondary"
                        style={{ marginBottom: "16px" }}
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
              <FormField
                control={form.control}
                name="additionalRemarks"
                render={({ field }) => (
                  <FormItem>
                    <FormLabel>Additional Remarks</FormLabel>
                    <FormControl>
                      <Textarea
                        disabled={updatingStatus || (isCCACalls && canCancel)}
                        {...field}
                        className="min-w-full border-secondary mb-4"
                        style={{ marginBottom: "16px" }}
                      />
                    </FormControl>
                  </FormItem>
                )}
              />
              {form.formState?.errors.failure ? (
                <p className="text-red-500 font-sm">
                  {form.formState?.errors.failure.message}
                </p>
              ) : (
                <></>
              )}
              <div className="flex flex-row justify-end w-full">
                <Button
                  variant="secondary"
                  type="submit"
                  disabled={updatingStatus || (isCCACalls && canCancel)}
                >
                  Update
                </Button>
              </div>
            </form>
          </Form>
        </DialogHeader>
      </DialogContent>
    </Dialog>
  );
}
